import { apiGet } from "../serverApi";
import { LocalApiStorer, LocalStorer } from "./LocalStorer";

export const auctionHouseStorage = new LocalApiStorer<ApiAuctionHouseEntry[]>({
    storageKey: "auctionHouses",
    maxAge: 10 * 60 * 1000,
    defaultData: [],
    loadFunc: async () => {
        const res = await apiGet<ApiAuctionHouseListResponse>("/api/ahs");
        if (res.error) throw new Error(res.error.message);
        for (const entry of res.data.data) {
            entry.lastUpdate *= 1000;
        }
        return res.data.data;
    },
    autoLoad: true,
});

export type FavoriteEntry = {
    itemId: number;
    itemName: string;
    qualityId: number;
    iconName: string;
    iconId: number;
};

export const favoriteStorage = new LocalStorer<{ favs: FavoriteEntry[] }>({
    storageKey: "favorites",
    defaultData: { favs: [] },
});
